import RemoteEvaluateRequest from "../../../../../mode/remote/RemoteEvaluateRequest"
import { HackleUser, InAppMessagePlatformType } from "../../../../../../model/model"
import WorkspaceEvaluation from "../../../../../../workspace/evaluation/WorkspaceEvaluation"
import InAppMessageEligibilityRemoteEvaluateResult from "../../../../../../workspace/evaluation/entity/InAppMessageEligibilityRemoteEvaluateResult"
import { InAppMessageEvaluateScope } from "../../../InAppMessageEvaluateScope"
import { InAppMessageEligibilityEvaluateRequest } from "../../InAppMessageEligibilityEvaluateRequest"

/**
 * An eligibility request resolved by remote evaluation. Its in-app message is the server-resolved
 * result, which carries the eligibility decision (isEligible/reason) and the nested layout result.
 */
export class InAppMessageEligibilityRemoteEvaluateRequest
  implements RemoteEvaluateRequest, InAppMessageEligibilityEvaluateRequest
{
  private constructor(
    readonly workspace: WorkspaceEvaluation,
    readonly user: HackleUser,
    readonly entity: InAppMessageEligibilityRemoteEvaluateResult,
    readonly scope: InAppMessageEvaluateScope,
    readonly platformType: InAppMessagePlatformType,
    readonly timestamp: number,
    readonly record: boolean
  ) {}

  get inAppMessage(): InAppMessageEligibilityRemoteEvaluateResult {
    return this.entity
  }

  static of(
    workspace: WorkspaceEvaluation,
    user: HackleUser,
    entity: InAppMessageEligibilityRemoteEvaluateResult,
    scope: InAppMessageEvaluateScope,
    platformType: InAppMessagePlatformType,
    timestamp: number,
    record = true
  ): InAppMessageEligibilityRemoteEvaluateRequest {
    return new InAppMessageEligibilityRemoteEvaluateRequest(
      workspace,
      user,
      entity,
      scope,
      platformType,
      timestamp,
      record
    )
  }

  toString(): string {
    return `InAppMessageEligibilityRemoteEvaluateRequest(key=${this.inAppMessage.key})`
  }
}
